import { classnames, fCredit } from '@aibees/shared/utils';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import type { PlanPriceProps as Props } from './types';

export const PlanPrice = memo(({ className }: Props) => {
  const { isPaid, selectedPlan } = usePlanCardContext();

  return (
    <Styled.Wrapper
      className={classnames('PlanPrice', className)}
      variant="h3"
      fontWeight={700}
      color={isPaid ? 'common.white' : 'common.black'}
    >
      ${isPaid ? fCredit(selectedPlan?.amount || 0) : 0}
    </Styled.Wrapper>
  );
});

PlanPrice.displayName = 'PlanPrice';
